module.exports = __webpack_public_path__ + "media/images/flags/UZ-4176214c50cf3850b3f79571445a8d34.svg";